module.exports = __webpack_public_path__ + "media/components/resources/grid/prototype/thumb3-777f1fc2012b00e1f11bae9f871238e5.jpg";